export function buildAnalyticsQuery({ preset = "30d", dateFrom = "", dateTo = "" }) {
  if (preset === "custom" && dateFrom && dateTo) {
    return { dateFrom, dateTo, preset: "custom" };
  }
  return { preset: preset === "custom" ? "30d" : preset };
}

export function formatPercent(rate) {
  if (rate == null) return "—";
  return `${(Number(rate) * 100).toFixed(1)}%`;
}

export function formatHours(hours) {
  if (hours == null) return "—";
  if (hours < 24) return `${Number(hours).toFixed(1)} hrs`;
  return `${(hours / 24).toFixed(1)} days`;
}
